import configs from "../configs";
import Vue from "vue";
import accounting from "accounting";
import leftPad from "left-pad";

const ip = configs.apiBase + "/v1/";

const toXlsx = (json) => {
  return Vue.prototype.$http.post(`${ip}xlsx`, json, {
    responseType: "arraybuffer",
  });
};

const download = (data, nome) => {
  // console.log(blob.type)
  let blob = new Blob([data], { type: data.type });
  let e = document.createEvent("MouseEvents");
  let a = document.createElement("a");
  a.download = nome;
  a.href = window.URL.createObjectURL(blob);
  a.dataset.downloadurl = [data.type, a.download, a.href].join(":");
  e.initMouseEvent(
    "click",
    true,
    false,
    window,
    0,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null,
  );
  a.dispatchEvent(e);
};

const openFileInNewTab = (data) => {
  const blob = new Blob([data], { type: data.type });
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL);
};

const fileToURL = (data) => {
  const blob = new Blob([data], { type: data.type });
  const fileURL = URL.createObjectURL(blob);
  return fileURL;
};

const toCurrency = (vl, prefix = "R$") => {
  return accounting.formatMoney(vl, prefix, 2, ".", ",");
};

const dateToString = (date) => {
  return `${leftPad(date.substring(8, 10), 2, 0)}/${leftPad(
    date.substring(5, 7),
    2,
    0,
  )}/${date.substring(0, 4)}`;
};

export default {
  toXlsx,
  download,
  openFileInNewTab,
  fileToURL,
  toCurrency,
  dateToString,
};
